/* eslint-disable no-unused-vars */
/**
 * @typedef {Object} SimpleOrgTreeNodeType
 * @property {string} id - Time the break started
 * @property {string} level - Time the break ended
 */

/**
 * @class
 */
export default class SimpleOrgTreeNode {
  /**
   * Create a new SimpleOrgTreeNode.
   * @param {SimpleOrgTreeNodeType} params
   */
  constructor(params) {
    this.id = params.id
    this.level = params.level
  }
}
